module.exports = __webpack_public_path__ + "static/img/home-four-3.557dc39.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home-four-3.png
// module id = NVhN
// module chunks = 1